export default __webpack_public_path__ + "static/media/calendarIcon.759b937e.svg";